import React from "react";

import { Button, ButtonGroup } from "aible";
import Select from "react-select";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagic,
  faAward,
  faBrain,
  faBars,
  faTrophy,
  faArrowUp,
  faArrowDown,
  faThumbsUp,
  faThumbsDown,
  faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";

import { DeleteButton } from "components/Home/Utils/Utils";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { LineInput } from "components/Inputs/LineInput";
import MaxChart from "components/FeatureChart/MaxChart";
import PieChart from "components/FeatureChart/PieChart";

import AibleStep from "components/CreateWizard/AibleStep";
import ModelTile from "containers/Tiles/ModelTile";
import ForecastChart from "containers/ForecastChart/PredictionChart";

import ModelsChart from "components/nHotdogChart/ModelsChart";
import SHotdogChart from "components/nHotdogChart/sHotdogChart";

import PredictionDriversCompanion from "components/FeatureChart/PredictionDriversCompanion";

import styles from "./style.module.css";

import { getFieldRange } from "containers/Predict/reducer";
import { isEnabled } from "utils/featureFlags";

export default class FeatureChartMini extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  getMinMax(bar, label) {
    if (label && label.includes(" to ")) {
      const retRange = getFieldRange(label);
      retRange.field = bar.label;
      retRange.label = bar.label + ": " + retRange.label;
      return retRange;
    } else {
      return {
        label: bar.label + ": " + this.replaceName(label),
        value: label,
        field: bar.label
      };
    }
  }

  replaceName(name) {
    return name === "Blank-Aible" ? "I Don't Know" : name === "Rare-Value-Aible" ? "Rare-Value" : name;
  }

  renderPredict() {
    const {
      colSelections,
      handlePredict,
      handleRestfulDeploy,
      scenarios,
      isPredictLoading,
      featureBars,
      isHideSelect,
      successStrings,
      deployments,
      outcome,
      trueAction,
      falseAction,
      models,
      isQuickRun,
      predictModels,
      updatePredictModels,
      updateScenarioIndex,
      updateFieldOption,
      updateFieldOptions,
      isContinuous,
      resetMinMax,
      updateHoverValue,
      chooseScenario,
      scenarioIndex,
      model,
      fields,
      minMax,
      deleteScenario,
      ignored,
      ignoredValue
    } = this.props;

    const deployment =
      deployments && model
        ? deployments.filter((d) => d.model_name === model.label) &&
          deployments.filter((d) => d.model_name === model.label)[0]
        : undefined;

    const isMinMax = minMax && minMax.field !== undefined;

    const deploymentsStarting = deployments
      ? deployments.filter((d) => d.status !== "RUNNING" && d.status !== "ERROR").length
      : 0;

    const isNewPredict = scenarioIndex === "new" || scenarioIndex === undefined;

    const scenario =
      scenarios && scenarios.filter((s) => s.id === scenarioIndex).length > 0
        ? scenarios.filter((s) => s.id === scenarioIndex)[0]
        : undefined;

    const thresholdCheck = model
      ? model.maxIteration
        ? model.maxIteration.threshold * 100
        : model.confusionMatrix
          ? model.confusionMatrix.threshold * 100
          : undefined
      : undefined;

    const prediction =
      scenario && scenario.predictions
        ? scenario.predictions.map((prediction) => {
            const retPrediction = { ...prediction };
            retPrediction.model = model.label;
            if (!isNaN(thresholdCheck)) {
              if (retPrediction.probability > thresholdCheck) {
                retPrediction.prediction = "1.0";
              } else {
                retPrediction.prediction = "0.0";
              }
            }
            return retPrediction;
          })
        : undefined;

    let options = [];

    for (let bar of featureBars) {
      const field = fields && fields[bar.label];

      if (field && field.type !== "number" && bar.values) {
        Object.keys(bar.values).forEach((v) =>
          options.push({
            label: bar.label + ": " + this.replaceName(v),
            value: v,
            field: bar.label
          })
        );
      }

      if (field && field.type === "number" && bar.values) {
        Object.keys(bar.values).forEach((v) => {
          options.push(this.getMinMax(bar, v));
        });

        //options = options.sort((a, b) => a.min - b.min);
      }

      if (field === undefined) {
        Object.keys(bar.values).forEach((v) =>
          options.push({
            label: bar.label + ": " + this.replaceName(v),
            value: v,
            field: bar.label
          })
        );
      }
    }

    const selOptions = colSelections
      ? Object.keys(colSelections)
          .filter((c) => colSelections[c] !== "Blank-Aible")
          .map((c) => ({ field: c, value: colSelections[c] }))
      : undefined;

    let chooseOptions = [];

    if (selOptions) {
      for (const option of selOptions) {
        for (const tOption of options) {
          if (option.field === tOption.field) {
            if (option.value === tOption.value) {
              chooseOptions.push(tOption);
            } else if (
              (tOption.min && option.value > tOption.min && option.value < tOption.max) ||
              (option.value === tOption.min && option.value === tOption.max)
            ) {
              chooseOptions.push(tOption);
            }
          }
        }
      }
    }

    return (
      <div className={styles.predictHolder}>
        {scenarios !== undefined && scenarios.length > 0 && (
          <div className={styles.chartButtonHolderMini}>
            <div className={styles.buttonTitleMini} style={{ fontSize: "13px" }}>
              {"Scenarios:"}
            </div>
            <ButtonGroup>
              <Button
                onClick={() => updateScenarioIndex("new")}
                type="secondary"
                active={isNewPredict && scenarios && scenarios.length > 0}
                disabled={scenarios === undefined || scenarios.length === 0}
                style={{ fontSize: "13px" }}
              >
                {"New"}
              </Button>
              {scenarios &&
                Object.keys(scenarios).map((s, i) => {
                  const scen = scenarios[s];

                  return (
                    <Button
                      onClick={() => chooseScenario(scenarios[s])}
                      key={i}
                      type="secondary"
                      active={scenarioIndex === scen.id}
                      style={{ fontSize: "13px" }}
                    >
                      {scen.isLoading === 0 ? scen.id + 1 : "..."}
                    </Button>
                  );
                })}
            </ButtonGroup>
          </div>
        )}
        <div className={styles.miniOptions}>
          <div className={styles.pTitle} style={{ width: "100%" }}>
            {"Choose a Scenario"}
            {scenarioIndex !== "new" ? <DeleteButton type={"current scenario"} clickHandler={deleteScenario} /> : ""}
          </div>
          <div style={{ width: "100%" }}>
            <div className={styles.miniSelect} style={{ marginTop: "10px" }}>
              <Select
                id="tabPredictSelect"
                options={options ? options : []}
                onChange={(val) => updateFieldOptions(val)}
                value={chooseOptions}
                isMulti
                placeholder={"Click to specify a prediction scenario"}
              />
            </div>
            {fields && (
              <div className={styles.miniSelect + " " + styles.secondSelect}>
                {"Optimize by changing:"}
                <span className={styles.sHolder}>
                  <Select
                    options={Object.keys(fields)
                      .filter((f) => f !== outcome && !ignored[f])
                      .map((f) => ({ label: f, value: f }))}
                    value={minMax ? { label: minMax.field, value: minMax.field } : undefined}
                    onChange={(val) =>
                      val === null ? resetMinMax(undefined) : updateFieldOption(val.value, "@_@Scenario@_@")
                    }
                    placeholder={"Select Field"}
                    isClearable
                  />
                </span>
              </div>
            )}
          </div>
        </div>
        {scenario && scenario.isLoading !== 0 ? (
          <div className={styles.miniDeployStarter}>
            <LoadingIndicator style={{ margin: "0px", marginBottom: "0px" }} />
            {deploymentsStarting !== 0 && <div className={styles.pMsg}>{"Starting deployment..."}</div>}
            {deploymentsStarting !== 0 && <div className={styles.pMsg}>{"This can take up to 5 minutes..."}</div>}
            {deploymentsStarting === 0 && deployment && deployment.status === "ERROR" ? (
              <div className={styles.pMsg}>{"Error Deploying..."}</div>
            ) : (
              <div className={styles.pMsg}>{"Calculating prediction..."}</div>
            )}
          </div>
        ) : prediction ? (
          prediction.length === 1 ? (
            prediction.map((p, index) => {
              return isContinuous !== true ? (
                <div className={styles.miniPredictionCircle} key={index}>
                  <div
                    className={styles.circleHolder}
                    style={
                      p.prediction === "1.0"
                        ? {
                            background: "#512f77",
                            color: "white"
                          }
                        : { color: "#4ba6ba", border: "5px solid #4ba6ba" }
                    }
                  >
                    <FontAwesomeIcon icon={p.prediction === "1.0" ? faThumbsUp : faThumbsDown} />
                  </div>
                  <div className={styles.takeAction}>
                    {p.prediction === "1.0" ? "Take Action" : "Don't Take Action"}
                  </div>
                  <div className={styles.miniTakeAction}>
                    {p.prediction === "1.0" ? "(" + trueAction + ")" : "(" + falseAction + ")"}
                  </div>
                </div>
              ) : (
                <div className={styles.miniPrediction} key={index}>
                  <div className={styles.emptyPie}>
                    <div className={styles.predMsgCont}>{Number(p.prediction).toFixed(4)}</div>
                  </div>
                  <div className={styles.pMsg}>{"Predicted " + outcome}</div>
                </div>
              );
            })
          ) : !isQuickRun && !isContinuous ? (
            <div className={styles.flexHelp}>
              {prediction.filter((p) => p.prediction === "1.0").length > 0 && (
                <div
                  className={styles.miniPredictionCircle}
                  style={prediction.filter((p) => p.prediction !== "1.0").length > 0 ? {} : {}}
                >
                  <div
                    className={styles.circleHolder}
                    style={{
                      background: "#512f77",
                      color: "white"
                    }}
                  >
                    <FontAwesomeIcon icon={faThumbsUp} />
                  </div>
                  <div className={styles.takeAction}>{"Take Action"}</div>
                  <div className={styles.miniTakeAction}>{"(" + trueAction + ")"}</div>
                  <div className={styles.valHolder}>
                    {prediction
                      .filter((p) => p.prediction === "1.0")
                      .sort((a, b) => b.probability - a.probability)
                      .map((p, i) => (
                        <div className={styles.pVal} key={i}>
                          {p.value}
                        </div>
                      ))}
                  </div>
                </div>
              )}
              {prediction.filter((p) => p.prediction !== "1.0").length > 0 && (
                <div className={styles.miniPredictionCircle}>
                  <div className={styles.circleHolder} style={{ color: "#4ba6ba", border: "5px solid #4ba6ba" }}>
                    <FontAwesomeIcon icon={faThumbsDown} />
                  </div>
                  <div className={styles.takeAction}>{"Don't Take Action"}</div>
                  <div className={styles.miniTakeAction}>{"(" + falseAction + ")"}</div>
                  <div className={styles.valHolder}>
                    {prediction
                      .filter((p) => p.prediction !== "1.0")
                      .sort((a, b) => b.probability - a.probability)
                      .map((p, i) => (
                        <div className={styles.pVal} key={i}>
                          {p.value}
                        </div>
                      ))}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <MaxChart
              outcome={outcome}
              prediction={prediction}
              successStrings={successStrings}
              isQuickRun={isQuickRun}
              updateHoverValue={(value) => updateHoverValue(value)}
            />
          )
        ) : (
          <div className={styles.pButton}>
            <Button
              type="primary"
              className={styles.bigButton}
              onClick={() => handlePredict()}
              disabled={chooseOptions.length === 0 && minMax === undefined}
              title={
                chooseOptions.length === 0 && minMax === undefined
                  ? "Select values to predict"
                  : isContinuous
                    ? "Predict " + outcome
                    : "Calculate Scenario"
              }
            >
              {isContinuous ? "Predict " + outcome : "Calculate Scenario"}
            </Button>
          </div>
        )}
      </div>
    );
  }

  render() {
    const {
      id,
      models,
      model,
      isSmall,
      isHideSelect,
      isResults,
      isTableau,
      isQuickRun,
      featureBars,
      modelBars,
      isTabMini,
      fieldSelect,
      hideRight,
      colSelections,
      valueSelect,
      outcome,
      onClick,
      label,
      isForecast,
      fields,
      ignored,
      hideTitle,
      predictMode,
      hoverValue,
      featureStyle,
      updateFieldSelect,
      updateValueSelect,
      updateFeatureSelection,
      updateFieldOption,
      updateHoverValue,
      updatePredictMode
    } = this.props;

    if (models === undefined || model === undefined) {
      return <div />;
    }

    const hasFeatures =
      (model.hasFeatures === true && model.featureInfo && model.featureInfo.length > 0) || predictMode === "predict";

    if ((isSmall && hasFeatures !== true) || (predictMode === "predict" && model && model.id === "Current State")) {
      return <div className={styles.notAvailable}>{"Not available for this model"}</div>;
    } else if (hasFeatures !== true) {
      return (
        <div style={{ height: "100%", width: "100%" }}>
          <div className={styles.cTitle}>{"Top Model Drivers"}</div>
          <div className={styles.notAvailable}>{"Not available for this model"}</div>
        </div>
      );
    }

    return (
      <div
        className={styles.features}
        style={{
          opacity: hasFeatures ? 1 : 1
        }}
      >
        <div className={styles.chartHolder}>
          <div
            className={isQuickRun ? styles.quickFeatureHolder : styles.featureHolder}
            style={{
              ...featureStyle,
              width: isHideSelect
                ? "100%"
                : isSmall && predictMode === "predict"
                  ? "0%"
                  : isSmall && predictMode !== "predict"
                    ? "100%"
                    : predictMode === "forecast"
                      ? "0%"
                      : isHideSelect && predictMode === "predict"
                        ? "0%"
                        : "50%"
            }}
          >
            <div className={styles.dTitle}>{"Top Model Drivers"}</div>
            <div className={styles.subTitle}>
              {isTableau
                ? "Click on a variable to view the Drill Down and Marginal Effects charts."
                : label
                  ? label
                  : "Select a variable to build a predict scenario"}
            </div>
            <div className={styles.lHolder}>
              <div className={styles.legend}>
                <div className={styles.dFieldPredict}>
                  <div className={styles.dItem}>
                    <span className={styles.dIconBad}>
                      <FontAwesomeIcon icon={faArrowDown} />
                    </span>
                  </div>
                  <div className={styles.dItem}>{"Decrease"}</div>
                </div>
                <div className={styles.dFieldPredict}>
                  <div className={styles.dItem}>
                    <span className={styles.dIconGood}>
                      <FontAwesomeIcon icon={faArrowUp} />
                    </span>
                  </div>
                  <div className={styles.dItem}>{"Increase"}</div>
                </div>
              </div>
              {isHideSelect !== true && isResults !== true && (
                <div className={styles.valLegend}>{"Selected Value"}</div>
              )}
            </div>
            {hasFeatures || predictMode === "predict" ? (
              <SHotdogChart
                {...this.props}
                bars={isSmall ? featureBars.filter((f, i) => i < 3) : featureBars}
                isSmall={isSmall}
                isNotMini={true}
                handleSelect={(label) => updateFieldSelect(label)}
                updateValueSelect={(label) => updateValueSelect(label)}
                updateFieldOption={(field, option) => updateFieldOption(field, option)}
                selected={fieldSelect}
                valueSelect={valueSelect}
                fields={fields}
                predictMode={predictMode}
                colSelections={colSelections}
                hoverValue={hoverValue}
                updateHoverValue={(val) => updateHoverValue(val)}
                onClick={onClick ? (val) => onClick(val) : undefined}
                isQuickRun={isQuickRun}
              />
            ) : (
              ""
            )}
          </div>
          {hideRight !== true && (
            <div
              className={styles.rightFeatures}
              style={{
                width: isHideSelect
                  ? "0%"
                  : !hasFeatures
                    ? "0%"
                    : isSmall && predictMode === "predict"
                      ? "100%"
                      : isSmall && predictMode !== "prediction"
                        ? "0%"
                        : predictMode === "forecast"
                          ? "100%"
                          : isHideSelect && predictMode === "predict"
                            ? "100%"
                            : "50%"
              }}
            >
              {predictMode === "drivers" && isSmall !== true ? (
                <PredictionDriversCompanion {...this.props} />
              ) : predictMode === "predict" ? (
                this.renderPredict()
              ) : predictMode === "forecast" ? (
                <ForecastChart id={id} />
              ) : (
                <div />
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}
